<template>
  <CustomToast :toasts="toastStore.state.toasts" @close-toast="toastStore.hideToast" />
  <router-view />
</template>

<script>
import { toastStore } from './store/toastStore';
import CustomToast from './components/CustomToast.vue';
import ProLeadMaintenance from '@/assets/images/prolead-maintenance.png';
import axios from 'axios';
import { onMounted } from 'vue';
import { RAILS_URL } from './config';

const path = window.location.pathname.replace(/\/+$/, '');

axios.defaults.withCredentials = true;

let redirecting = false;

async function healthProbe(timeoutMs = 3000) {
  const c = new AbortController();
  const id = setTimeout(() => c.abort(), timeoutMs);
  try {
    const res = await fetch(`${RAILS_URL}/health`, {
      signal: c.signal,
      credentials: 'omit',
      cache: 'no-store',
    });
    const body = res.ok ? await res.json().catch(() => ({})) : {};
    return body?.status === 'UP';
  } catch {
    return false;
  } finally {
    clearTimeout(id);
  }
}

async function confirmDown() {
  const firstTry = await healthProbe();
  if (firstTry) return false;

  await new Promise(r => setTimeout(r, 800));
  const secondTry = await healthProbe();
  return !secondTry;
}

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const code = error.response?.status;
    const cors = !error.response;

    if (!redirecting && (code === 503 || code === 426 || cors) && path !== '/new-admin/maintenance') {
      if (await confirmDown()) {
        redirecting = true;
        window.location.href = '/new-admin/maintenance';
        return Promise.reject(error);
      }
    }

    const offline = error.message === 'Network Error' || error.code === 'ERR_NETWORK';

    if (!cors && offline) {
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default {
  components: {
    CustomToast,
  },
  setup() {
    onMounted(async () => {
      if (import.meta.env.VITE_ENV === 'production' || import.meta.env.VITE_ENV === 'staging') {
        if (path !== '/new-admin/maintenance' && (await confirmDown())) {
          redirecting = true;
          window.location.href = '/new-admin/maintenance';
        }
      }
    });

    return {
      toastStore,
      ProLeadMaintenance,
    };
  },
};
</script>
